import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-rodape-crud',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './rodape-crud.component.html',
  styleUrls: ['./rodape-crud.component.css']
})
export class RodapeCrudComponent {
  @Input() exibirExcluir = false;
  @Input() excluirDesabilitado = false;
  @Output() excluir = new EventEmitter<void>();
  @Output() limpar = new EventEmitter<void>();
  @Output() salvar = new EventEmitter<void>();
}
